class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverEnabled = ['HeaderMenu-bedurfnisse', 'HeaderMenu-is-clinical', 'HeaderMenu-circadia', 'HeaderMenu-behandlungen'].includes(this.summary.id);
    if (!this.hoverEnabled) return;

    this.addEventListener('pointerenter', (event) => {
      this.clearHoverTimers();
      if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches) return;
      this.openTimer = setTimeout(() => {
        document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
          if (menu !== this) menu.close();
        });
        this.mainDetailsToggle.open = true;
        this.summary.setAttribute('aria-expanded', 'true');
      }, 200);
    });
    this.addEventListener('pointerleave', (event) => {
      this.clearHoverTimers();
      if (event.pointerType !== 'mouse') return;
      this.closeTimer = setTimeout(() => {
        if (!this.content.contains(document.activeElement)) this.close();
      }, 250);
    });
    this.summary.addEventListener('click', () => this.clearHoverTimers());
  }

  clearHoverTimers() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
  }

  disconnectedCallback() {
    this.clearHoverTimers();
  }

  close() {
    this.clearHoverTimers();
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
